import 'froala-editor/css/froala_style.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/js/plugins.pkgd.min.js'
import 'froala-editor/js/plugins/link.min.js'
import 'froala-editor/js/plugins/image.min.js'
import 'froala-editor/js/languages/fr.js'
import './Froala.css'

import FroalaEditorComponent from 'react-froala-wysiwyg'

import { isFrenchLocale } from 'lib/utility/LocaleHelper'

type ChangeEvent = {
  target: {
    name: string
    value: string
  }
}

type EditorProps = {
  name: string
  value: string
  config: object
  placeholder?: string
  onChange: (event: ChangeEvent) => void
}

function Editor({ name, value, config, onChange, placeholder }: EditorProps) {
  const getFroalaConfig = () => {
    return isFrenchLocale()
      ? Object.assign({}, config, { language: 'fr' })
      : placeholder
      ? Object.assign({}, config, { placeholderText: placeholder })
      : config
  }
  const handleChange = (model: string) =>
    onChange({ target: { name, value: model } })

  return (
    <FroalaEditorComponent
      tag="textarea"
      model={value}
      config={getFroalaConfig()}
      onModelChange={handleChange}
    />
  )
}

export default Editor
export type { EditorProps }
